module.exports = __webpack_public_path__ + "static/orion-9bb6cf63ddb4d217e3c07fc4dbd45470.png";